import React, { useState } from 'react';
import GroupEditor from "../GroupEditor";
import useLocalStorage from "../../hooks/useLocalStorage";

function MoveZeroes() {
    const [script, setScript] = useLocalStorage('moveZeroesScript', `function moveZeroes(nums) {
            
}
    `);
    const [resultText, setResultText] = useState('');
    const [syntaxError, setSyntaxError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [resultTextCss, setResultTextCss] = useState('');
    const [srcDoc, setSrcDoc] = useState('');

    const testCases = [
        { input: [0,1,0,3,12], expected: [1,3,12,0,0] },
        { input: [0], expected: [0] },
        { input: [1,2,3,4,5], expected: [1,2,3,4,5] },
        { input: [0,0,1], expected: [1,0,0] }
    ];

    function executeScript() {
        setSyntaxError(false);
        setErrorMessage('');
        setResultText('');

        try {
            const results = testCases.map(({ input }) => {
                const scriptFunction = new Function(`
                    ${script}
                    let arr = ${JSON.stringify(input)};
                    moveZeroes(arr);
                    return arr;
                `);
                return { input, result: scriptFunction() };
            });

            const formattedOutput = results.map(({ input, result }) =>
                `<div><strong>Input:</strong> ${JSON.stringify(input)} | <strong>Output:</strong> ${JSON.stringify(result)}</div>`
            ).join('');
            setSrcDoc(`<!DOCTYPE html><html><body>${formattedOutput}</body></html>`);

            checkPassed(results.map(r => r.result));
        } catch (e) {
            setSyntaxError(true);
            setResultTextCss('');
            setResultText('Ergebnis kann nicht ausgewertet werden, da dein Code noch einen oder mehrere Syntaxfehler hat:');
            setErrorMessage(e.message);
            setSrcDoc(`<!DOCTYPE html>
                <html>
                <head><style>body { font-family: Arial, sans-serif; color: red; }</style></head>
                <body><div>Fehler: ${e.message}</div></body>
                </html>`);
        }
    }

    function checkPassed(results) {
        const isCorrect = results.every((result, index) => JSON.stringify(result) === JSON.stringify(testCases[index].expected));

        if (isCorrect) {
            setResultTextCss('success-result');
            setResultText("Deine Lösung ist korrekt!");
        } else {
            setResultTextCss('error-message');
            setResultText("Deine Lösung ist leider falsch. Bitte überprüfe deinen Code und versuche es erneut.");
        }
    }

    return (
        <>
            <div className="aufgaben-container">
                <h2>Kaputte Null-Verschiebung</h2>
                Deine Aufgabe ist es, eine Funktion zu erstellen, die alle Nullen in einem Array ans Ende verschiebt, während die relative Reihenfolge der anderen Elemente beibehalten wird.
                <br/><br/>
                Anforderungen:
                <ul>
                    <li>Die Funktion soll alle Nullen im Array ans Ende verschieben.</li>
                    <li>Die Reihenfolge der nicht-null Werte muss beibehalten werden.</li>
                    <li>Die Operation muss in-place durchgeführt werden, ohne ein neues Array zu erstellen.</li>
                </ul>
                Sobald du deinen Code implementiert hast, kannst du ihn ausführen, um zu sehen, ob die Verschiebung korrekt ist.
            </div>

            <div className="aufgaben-container">
                <GroupEditor
                    language="javascript"
                    value={script}
                    onChange={setScript}
                    editorKey="moveZeroesScript"
                />
            </div>

            <button className="submit-code-button" onClick={executeScript}>▶ Code ausführen</button>

            <div className="ergebnis-text">
                Ergebnis: <br/>
                <div className={resultTextCss}>{resultText}</div>
                {syntaxError && <div className="error-message">{errorMessage}</div>}
            </div>

            <div className="result-frame">
                <iframe
                    title="console-output"
                    srcDoc={srcDoc}
                    sandbox="allow-scripts"
                    width="100%"
                    height="40%"
                />
            </div>
        </>
    );
}

export default MoveZeroes;
